export const RewindIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8.40357 7.30373C7.86548 7.6159 7.86548 8.38415 8.40357 8.69633L14.7672 12.3882C15.2874 12.69 16 12.3452 16 11.6919V4.30816C16 3.6549 15.2874 3.31005 14.7672 3.61186L8.40357 7.30373Z"
      fill="#667180"
    />
    <path
      d="M0.403571 7.30373C-0.134524 7.6159 -0.134524 8.38415 0.403571 8.69633L6.76721 12.3882C7.28744 12.69 8 12.3452 8 11.6919V4.30816C8 3.6549 7.28744 3.31005 6.76721 3.61186L0.403571 7.30373Z"
      fill="#667180"
    />
  </svg>
);
